module.exports = __webpack_public_path__ + "b3595c763d06b51615f1217b3d0be5d4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/scarf-pink.png
// module id = 1994
// module chunks = 0